export default "__VITE_ASSET__DxNJU6ie__"